import React, { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth";
import { api, V1 } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter,
} from "@/components/ui/dialog";
import { Plus, Calendar } from "lucide-react";
import { toast } from "sonner";

export default function SchoolExamsPage() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ title: "", description: "", grade_levels: "8", exam_date: "", application_start: "", application_end: "", quota: 100 });

  const load = () => user?.school_id && api.get(`${V1}/schools/${user.school_id}/scholarship-exams`).then((r) => setItems(r.data || []));
  useEffect(() => { load(); }, [user]);

  const create = async () => {
    try {
      await api.post(`${V1}/scholarship-exams`, {
        school_id: user.school_id,
        title: form.title,
        description: form.description,
        grade_levels: form.grade_levels.split(",").map((s) => s.trim()).filter(Boolean),
        exam_date: new Date(form.exam_date).toISOString(),
        application_start: new Date(form.application_start).toISOString(),
        application_end: new Date(form.application_end).toISOString(),
        quota: parseInt(form.quota),
      });
      toast.success("Sınav oluşturuldu");
      setOpen(false);
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Oluşturulamadı"); }
  };

  return (
    <div className="space-y-6" data-testid="school-exams-page">
      <div className="flex justify-between items-center">
        <div>
          <div className="overline text-accent">Bursluluk Sınavları</div>
          <h1 className="font-display text-3xl font-bold">Yayınlanmış Sınavlar</h1>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button data-testid="new-exam-btn"><Plus className="h-4 w-4" /> Yeni Sınav</Button></DialogTrigger>
          <DialogContent className="max-w-lg">
            <DialogHeader><DialogTitle>Bursluluk Sınavı Oluştur</DialogTitle></DialogHeader>
            <div className="grid gap-3">
              <div><Label>Başlık</Label><Input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="exam-title" /></div>
              <div><Label>Açıklama</Label><Textarea value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} /></div>
              <div><Label>Sınıflar (virgülle)</Label><Input value={form.grade_levels} onChange={(e) => setForm({ ...form, grade_levels: e.target.value })} placeholder="5,6,7,8" /></div>
              <div className="grid grid-cols-3 gap-2">
                <div><Label>Sınav Tarihi</Label><Input type="datetime-local" value={form.exam_date} onChange={(e) => setForm({ ...form, exam_date: e.target.value })} /></div>
                <div><Label>Başvuru Başlangıç</Label><Input type="datetime-local" value={form.application_start} onChange={(e) => setForm({ ...form, application_start: e.target.value })} /></div>
                <div><Label>Başvuru Bitiş</Label><Input type="datetime-local" value={form.application_end} onChange={(e) => setForm({ ...form, application_end: e.target.value })} /></div>
              </div>
              <div><Label>Kontenjan</Label><Input type="number" value={form.quota} onChange={(e) => setForm({ ...form, quota: e.target.value })} /></div>
            </div>
            <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Vazgeç</Button><Button onClick={create} data-testid="save-exam-btn">Yayınla</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {items.length === 0 && <div className="col-span-2 p-10 rounded-xl border border-dashed border-border text-center text-muted-foreground">Henüz bursluluk sınavı oluşturmadınız.</div>}
        {items.map((e) => (
          <div key={e.id} className="p-6 rounded-xl border border-border bg-card">
            <div className="text-xs text-muted-foreground flex items-center gap-1"><Calendar className="h-3 w-3" /> {new Date(e.exam_date).toLocaleDateString("tr-TR")}</div>
            <div className="font-display font-bold text-lg mt-1">{e.title}</div>
            <div className="text-sm text-muted-foreground mt-1">{e.description}</div>
            <div className="mt-3 flex gap-3 text-xs">
              <span>Sınıflar: {(e.grade_levels || []).join(", ")}</span>
              <span>Kontenjan: {e.quota}</span>
              <span className="px-2 py-0.5 bg-muted rounded uppercase tracking-widest">{e.status}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
